
import './App.css';
import Characters from './components/Characters';
import imageRickMorty from "./img/rick_morty_PNG20.png"
import { useState } from 'react';


function App() {

  const [characters, setCharacters] = useState(null);
  const reqApi = async() => {
    const api = await fetch('https://rickandmortyapi.com/api/character');
    const characterApi = await api.json();
    //console.log(characterApi);
    setCharacters(characterApi.results, characterApi.location);
    
    
  }

  return (
    <div className="App">
      <header className="App-header">
        <h2 className="title">Todo sobre los personajes de la serie Rick y Morty</h2>
        {}
        {characters ? (
          <Characters characters= {characters} setCharacters={setCharacters}/>
          
          

        ) : (
          <> 
          <img src={imageRickMorty} alt="Rick and Morty" className='img-home'/>
          <button onClick={reqApi} className='btn-search'>Buscar Personajes</button>
          </>
        )}
        

      </header>
    </div>
  );
}

export default App;
